import * as $ from 'jquery';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';
// import { NgIconsModule } from '@ng-icons/core';

// Locale
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es-MX';

// Rutas
import { APP_ROUTES } from './app-routes.module';

// Modulos
// import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { AgmCoreModule } from '@agm/core';
import { RouterModule } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { MatTableModule } from '@angular/material/table';

// Components
import { NavigationComponent } from './shared/header-navigation/navigation.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { BreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { SpinnerComponent } from './shared/spinner.component';
import { AppComponent } from './app.component';
import { NotFoundComponent } from './authentication/notfound/not-found.component';
import { LoginComponent } from './authentication/login/login.component';
import { RegisterComponent } from './authentication/register/register.component';
import { LockComponent } from './authentication/lock/lock.component';
import { HomeComponent } from './pages/home/home.component';
import { NgbdAlertBasicComponent } from './component/alert/alert.component';
import { CheckboxEditorComponent } from './custom-components/cell-editor/checkbox-editor.component';
import { SelectEditorComponent } from './custom-components/cell-editor/select-editor.component';
import { UiCardsComponent } from './pages/ui-cards/ui-cards.component';
//
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { FileUploadComponent } from './component/file-upload/file-upload.component';
import { SignatureModalComponent } from './component/signature-modal/signature-modal.component';
import { SignatureFielComponent } from './component/signature-fiel/signature-fiel.component';
import { ReviewerModalComponent } from './component/reviewer-modal/reviewer-modal.component';
import { HookArchiveComponent} from './component/hook-archive/hook-archive.component';
import { SignatureBulkModalComponent} from './component/signature-bulk-modal/signature-bulk-modal.component';
import { PowerOfAttorneyComponent } from './component/power-of-attorney/power-of-attorney.component';
import { PowerCatalogsComponent } from './component/power-catalogs/power-catalogs.component';
import { PowerCatalogElementComponent } from './component/power-catalog-element/power-catalog-element.component';
import { PowerModalComponent } from './component/power-modal/power-modal.component';
import { SocietySelectorComponent} from './component/society-selector/society-selector.component';
import { ErrorPageComponent} from './component/error-page/error-page.component'
import { CapitalizePipe } from './pipe/capitalize.pipe';
import { PdlPersonModalComponent } from './component/pdl-person-modal/pdl-person-modal.component';
import { RolSidebarComponent } from './shared/sidebar/rolbased/rol-sidebar/rol-sidebar.component';
import { RolSidebarItemComponent } from './shared/sidebar/rolbased/rol-sidebar-item/rol-sidebar-item.component';
import { PdlPersonFileComponent } from './component/pdl-person-file/pdl-person-file.component';
//


// Configuracion
// import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { NumericEditorComponent } from './custom-components/cell-editor/numeric-editor.component';
// import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TextEditorComponent } from './custom-components/cell-editor/text-editor.component';

// import { Ng2SmartTableModule } from 'ng2-smart-table';
import { Angular2SmartTableModule } from 'angular2-smart-table';


import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
// const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
//   suppressScrollX: true,
//   wheelSpeed: 1,
//   wheelPropagation: true,
//   minScrollbarLength: 20
// };
import { EnterKeyDirective } from './enter-key.directive';
import { CdkDropListGroup } from "@angular/cdk/drag-drop";
import { HttpErrorInterceptorProvider } from './services/http-error.interceptor';

registerLocaleData(localeEs);

// declare module "@angular/core" {
//     interface ModuleWithProviders<T = any> {
//       ngModule: Type<T>;
//       providers?: Provider[];
//     }
//   }

// export declare interface ModuleWithProviders<T> {
//     ngModule: Type<T>;
//     // providers?: Array<Provider | EnvironmentProviders>;
//     (Provider , EnvironmentProviders);
// }

// declare module "@angular/core" {
//     interface ModuleWithProviders<T = any> {
//         ngModule: Type<T>;
//         providers?: (Provider | EnvironmentProviders);
        
//     }
// }

@NgModule({
    declarations: [
        AppComponent,
        SpinnerComponent,
        NavigationComponent,
        BreadcrumbComponent,
        SidebarComponent,
        LoginComponent,
        HomeComponent,
        NotFoundComponent,
        RegisterComponent,
        LockComponent,
        NgbdAlertBasicComponent,
        CheckboxEditorComponent,
        SelectEditorComponent,
        NumericEditorComponent,
        TextEditorComponent,
        UiCardsComponent,
        FileUploadComponent,
        SignatureModalComponent,
        SignatureFielComponent,
        ReviewerModalComponent,
        HookArchiveComponent,
        EnterKeyDirective,
        SignatureBulkModalComponent,
        PowerOfAttorneyComponent,
        PowerCatalogsComponent,
        PowerCatalogElementComponent,
        PowerModalComponent,
        SocietySelectorComponent,
        ErrorPageComponent,
        CapitalizePipe,
        PdlPersonModalComponent,
        RolSidebarComponent,
        RolSidebarItemComponent,
        PdlPersonFileComponent
    ],
    imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    NgbModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    RouterModule.forRoot(APP_ROUTES, { useHash: true }),
    // PerfectScrollbarModule,
    NgxSpinnerModule,
    // AgmCoreModule.forRoot({ apiKey: 'AIzaSyBUb3jDWJQ28vDJhuQZxkC0NXr_zycm8D0' }),
    PdfViewerModule,
    // Ng2SmartTableModule
    Angular2SmartTableModule,
    NgxExtendedPdfViewerModule,
    MatTableModule
    //NgIconsModule
    ,
    CdkDropListGroup
],
    //exports: [ UiCardsComponent ],
    providers: [
        { provide: LOCALE_ID, useValue: 'es-MX' },
        HttpErrorInterceptorProvider,
        // { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}

// const cUiCardsComponent: UiCardsComponent ={};
